export const dataSlider = [
    {
        img: 'https://assets-global.website-files.com/5f4f71d4aeab4787c7926d10/62cc70a94fe9f26f25380827_Steve-Vassallo_Thumbnail.jpg',
        title: '#120 Foundation Capital: Reinventing a 27 Year Old Venture Capital Firm | Steve Vassallo, General Partner',
        desc: 'In Episode #120, we explore reinventing a well-established venture capital firm. We’re joined by Steve Vassallo, General Partner at Foundation Capital. We cover Minimum Awesome Product and the prepared mind vs. open mind.'
    },
    {
        img: 'https://assets-global.website-files.com/5f4f71d4aeab4787c7926d10/62ba0fde11ab0c8233c076a8_Michael-Brandt_Thumbnail.jpg',
        title: '#120 Foundation Capital: Reinventing a 27 Year Old Venture Capital Firm | Steve Vassallo, General Partner',
        desc: 'In Episode #120, we explore reinventing a well-established venture capital firm. We’re joined by Steve Vassallo, General Partner at Foundation Capital. We cover Minimum Awesome Product and the prepared mind vs. open mind.'
    },
    {
        img: 'https://assets-global.website-files.com/5f4f71d4aeab4787c7926d10/62c49329952d907662673af2_Adrian-Aoun_Thumbnail.jpg',
        title: '#120 Foundation Capital: Reinventing a 27 Year Old Venture Capital Firm | Steve Vassallo, General Partner',
        desc: 'In Episode #120, we explore reinventing a well-established venture capital firm. We’re joined by Steve Vassallo, General Partner at Foundation Capital. We cover Minimum Awesome Product and the prepared mind vs. open mind.'
    },
    {
        img: 'https://assets-global.website-files.com/5f4f71d4aeab4787c7926d10/62cc70a94fe9f26f25380827_Steve-Vassallo_Thumbnail.jpg',
        title: '#120 Foundation Capital: Reinventing a 27 Year Old Venture Capital Firm | Steve Vassallo, General Partner',
        desc: 'In Episode #120, we explore reinventing a well-established venture capital firm. We’re joined by Steve Vassallo, General Partner at Foundation Capital. We cover Minimum Awesome Product and the prepared mind vs. open mind.'
    },
    {
        img: 'https://assets-global.website-files.com/5f4f71d4aeab4787c7926d10/62cc70a94fe9f26f25380827_Steve-Vassallo_Thumbnail.jpg',
        title: '#120 Foundation Capital: Reinventing a 27 Year Old Venture Capital Firm | Steve Vassallo, General Partner',
        desc: 'In Episode #120, we explore reinventing a well-established venture capital firm. We’re joined by Steve Vassallo, General Partner at Foundation Capital. We cover Minimum Awesome Product and the prepared mind vs. open mind.'
    },
    {
        img: 'https://assets-global.website-files.com/5f4f71d4aeab4787c7926d10/62ba0fde11ab0c8233c076a8_Michael-Brandt_Thumbnail.jpg',
        title: '#120 Foundation Capital: Reinventing a 27 Year Old Venture Capital Firm | Steve Vassallo, General Partner',
        desc: 'In Episode #120, we explore reinventing a well-established venture capital firm. We’re joined by Steve Vassallo, General Partner at Foundation Capital. We cover Minimum Awesome Product and the prepared mind vs. open mind.'
    },
    {
        img: 'https://assets-global.website-files.com/5f4f71d4aeab4787c7926d10/62cc70a94fe9f26f25380827_Steve-Vassallo_Thumbnail.jpg',
        title: '#120 Foundation Capital: Reinventing a 27 Year Old Venture Capital Firm | Steve Vassallo, General Partner',
        desc: 'In Episode #120, we explore reinventing a well-established venture capital firm. We’re joined by Steve Vassallo, General Partner at Foundation Capital. We cover Minimum Awesome Product and the prepared mind vs. open mind.'
    },
    {
        img: 'https://assets-global.website-files.com/5f4f71d4aeab4787c7926d10/62f155cdacec7e666b9a127e_Saad-Alam_Thumbnail.jpg',
        title: '#120 Foundation Capital: Reinventing a 27 Year Old Venture Capital Firm | Steve Vassallo, General Partner',
        desc: 'In Episode #120, we explore reinventing a well-established venture capital firm. We’re joined by Steve Vassallo, General Partner at Foundation Capital. We cover Minimum Awesome Product and the prepared mind vs. open mind.'
    },
    {
        img: 'https://assets-global.website-files.com/5f4f71d4aeab4787c7926d10/62cc70a94fe9f26f25380827_Steve-Vassallo_Thumbnail.jpg',
        title: '#120 Foundation Capital: Reinventing a 27 Year Old Venture Capital Firm | Steve Vassallo, General Partner',
        desc: 'In Episode #120, we explore reinventing a well-established venture capital firm. We’re joined by Steve Vassallo, General Partner at Foundation Capital. We cover Minimum Awesome Product and the prepared mind vs. open mind.'
    }
]

export const smallCard = [
    {
        icon: 'fa-solid fa-fire-flame-curved',
        title: 'Trending Now',
        desc: 'Find the interviews and articles that are trending now.'
    },
    {
        icon: 'fa-solid fa-clock',
        title: 'New Relase',
        desc: 'Catch up on all of the latest interviews and articles.'
    },
    {
        icon: 'fa-solid fa-box-archive',
        title: 'The Archives',
        desc: 'Explore the archives by browsing categories and tags.'
    }
]


export const dataGaleryCard = [
    {
        orange_title: 'Listen NOW',
        title: 'Outliers Podcast',
        desc: "Every week, I sit down with someone in the Top 1% of their field to decode what they've mastered and what they've learned along the way.",
        btn_title: 'Explore Episodes',
        img_top_left: 'https://assets-global.website-files.com/5f46baf9863467a01b1aaab9/5f57692a5cc18d6016eefd60_ds-home-1.jpg',
        img_top_mid: 'https://assets-global.website-files.com/5f46baf9863467a01b1aaab9/5f57692c7ce6c8272dcc60f0_ds-home-11.jpg',
        img_top_rigth: 'https://assets-global.website-files.com/5f46baf9863467a01b1aaab9/5f57692a8d6cd9ff785a195a_ds-home-2.jpg',
        img_bot_left: 'https://assets-global.website-files.com/5f46baf9863467a01b1aaab9/5f57692a9e216472d88bde4e_ds-home-4.jpg',
        img_bot_mid: 'https://assets-global.website-files.com/5f46baf9863467a01b1aaab9/5f64cefe0bd5525277bdaac4_ds-home-12.jpg',
        img_bot_rigth: 'https://assets-global.website-files.com/5f46baf9863467a01b1aaab9/5f57692a00f5c3e885a74391_ds-home-3.jpg',
    },
    {
        orange_title: 'Subscribe NOW',
        title: 'Friday 5 Email',
        desc: "Every Friday, I share five things I've been reading, using, and loving—including articles, biohacks, gadgets, and more.",
        btn_title: 'Subscribe Now',
        img_top_left: 'https://assets-global.website-files.com/5f46baf9863467a01b1aaab9/5f57692b192d6f7ff58a3d10_ds-home-5.jpg',
        img_top_mid: 'https://assets-global.website-files.com/5f46baf9863467a01b1aaab9/5f57692bcf42ab6842e28978_ds-home-9.jpg',
        img_top_rigth: 'https://assets-global.website-files.com/5f46baf9863467a01b1aaab9/5f57692a074e08b6b0dbdf6c_ds-home-6.jpg',
        img_bot_left: 'https://assets-global.website-files.com/5f46baf9863467a01b1aaab9/5f57692b8fafa4950143f8da_ds-home-8.jpg',
        img_bot_mid: 'https://assets-global.website-files.com/5f46baf9863467a01b1aaab9/5f64d004dc9fe7d3fdd5c039_ds-home-10.jpg',
        img_bot_rigth: 'https://assets-global.website-files.com/5f46baf9863467a01b1aaab9/5f57692a081565ab4ae6f56a_ds-home-7.jpg',
    }
]

export const dataFooter = [
    {
        title: 'Explore',
        childs: ['Most Popular', 'Most Recent', 'Topics & Tags', 'Friday Five']
    },
    {
        title: 'Outliers',
        childs: ['Episodes', 'Subscribe Now', 'About the Show', 'Sponsors']
    },
    {
        title: 'Articles',
        childs: ['Show Notes', 'Transcripts', 'Essays', 'Snippets']
    },
    {
        title: 'Explore',
        childs: ['About Daniel', 'Business Card', 'Newsroom', 'Contact']
    }
]